import { issuesContract } from './issues.contract';
import { sortingSettingsContract } from './sortingSettings.contract';

// Individual re-exports (for route files importing specific contracts)
export { issuesContract } from './issues.contract';
export { sortingSettingsContract } from './sortingSettings.contract';

// Aggregated export for service client creation
export const issuesContracts = {
	issuesContract,
	sortingSettingsContract,
};
